module.exports = __webpack_public_path__ + "img/impeccable-investor-headshot.2f4edd1e.jpg";